import { render, staticRenderFns } from "./PrinterDownloads.vue?vue&type=template&id=6d05d703&scoped=true&"
import script from "./PrinterDownloads.vue?vue&type=script&lang=js&"
export * from "./PrinterDownloads.vue?vue&type=script&lang=js&"
import style0 from "./PrinterDownloads.vue?vue&type=style&index=0&id=6d05d703&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d05d703",
  null
  
)

export default component.exports